import axios from 'axios'
import config from '@/config'
import applyUrlTemplate from './applyUrlTemplate'
import applyDefaultParams from './applyDefaultParams'
import { applyCacheResuest, applyCacheResponse } from './cache'

import normalizeAxiosError from './normalizeAxiosError'

export const CLICK_REWARD_ERROR_CODES = {
  SERVER_ERROR: 500,
  // PERMISSION_DENIED: 251,
}

class ClickRewardApiError extends Error {
  constructor(code, message, cause = null) {
    super(message)

    this.code = code
    this.cause = cause
    this.name = 'ClickRewardApiError'
  }
}

export const isClickRewardApiError = err => {
  return err instanceof ClickRewardApiError
}

const clickRewardApi = axios.create({
  baseURL: config.clickRewardApiBaseUrl,
  timeout: 300 * 1000
})

clickRewardApi.interceptors.request.use(applyCacheResuest)
clickRewardApi.interceptors.request.use(applyUrlTemplate)
clickRewardApi.interceptors.request.use(applyDefaultParams)

clickRewardApi.interceptors.response.use(applyCacheResponse)
clickRewardApi.interceptors.response.use(null, normalizeAxiosError)
// clickRewardApi.interceptors.response.use(null, function (err) {
//   console.log(err)
//   if (err.status === 401) {
//     router.push({path: '/login'})
//   } else {
//     router.push({path: '/etc/dataerror'})
//   }
//   return Promise.reject(err)
// })

clickRewardApi.interceptors.response.use(
  function (response) {
    // 2xx 범위에 있는 상태 코드는 이 함수를 트리거
    // 응답 데이터가 있는 작업 수행
    if (response.data.error) {
      const { error } = response.data

      return Promise.reject(new ClickRewardApiError(error.code, error.message, response.data))
    }

    return response
  },
  function (error) {
    // 2xx 외의 범위에 있는 상태 코드는 이 함수를 트리거
    // 응답 오류가 있는 작업 수행

    return Promise.reject(error)
  },
)

export default clickRewardApi
